<template>
  <div class="contents-help-box">
    <div class="contents contents-help">
      <div class="contents-help-right">
        <img :src="helpimg" />
      </div>

      <div class="contents-help-left">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="help-line">
            <el-form-item class="help-item" prop="name">
              <el-input v-model="form.name" placeholder="名"></el-input>
            </el-form-item>
            <el-form-item class="help-item" prop="surname">
              <el-input v-model="form.surname" placeholder="姓"></el-input>
            </el-form-item>
          </div>

          <div class="help-line">
            <el-form-item class="help-item" prop="mail">
              <el-input v-model="form.mail" placeholder="邮箱"></el-input>
            </el-form-item>
            <el-form-item class="help-item" prop="phone">
              <el-input v-model="form.phone" placeholder="电话"></el-input>
            </el-form-item>
          </div>

          <el-form-item prop="company">
            <el-input v-model="form.company" placeholder="公司名称"></el-input>
          </el-form-item>

          <el-form-item prop="content">
            <el-input
              type="textarea"
              v-model="form.content"
              :rows="8"
              placeholder="让我们了解您遇到的问题，我们能帮您什么？"
            ></el-input>
          </el-form-item>

          <el-form-item prop="type">
            <el-checkbox-group v-model="form.type">
              <el-checkbox class="el-m-label" name="type"
                >当您提交信息后，我们将会以邮件或电话回复您，请您阅读<router-link
                  class="yinsi"
                  :to="{ name: 'privacy' }"
                  tag="a"
                  target="_blank"
                  >隐私政策</router-link
                >，我们将严格 按照您<br />同意的<router-link
                  class="yinsi"
                  :to="{ name: 'privacy' }"
                  tag="a"
                  target="_blank"
                  >隐私政策</router-link
                >使用您的个人信息，提交即表示您同意<router-link
                  class="yinsi"
                  :to="{ name: 'privacy' }"
                  tag="a"
                  target="_blank"
                  >隐私政策</router-link
                >。</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <el-form-item class="mbutton">
            <el-button
              round
              type="primary"
              class="help-button"
              @click="onSubmit('form')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var revalidatexieyi = (rule, value, callback) => {
      if (value === false) {
        callback(new Error("请同意协议"));
      } else {
        callback();
      }
    };
    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    var validatorCompany = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("公司名称不能为空"));
      } else if (value.length < 2) {
        callback(new Error("公司名称最少两个字符"));
      } else {
        callback();
      }
    };
    var validatorContent = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("问题不能为空"));
      } else if (value.length < 10) {
        callback(new Error("问题不能少于10个位"));
      } else {
        callback();
      }
    };

    return {
      helpimg: "/static/industry/helpimg.png",
      form: {
        name: "",
        surname: "",
        mail: "",
        phone: "",
        company: "",
        type: [],
        content: ""
      },
      rules: {
        name: [{ required: true, message: "请输入名", trigger: "blur" }],
        surname: [{ required: true, message: "请输入姓", trigger: "blur" }],
        mail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        company: [
          { required: true, validator: validatorCompany, trigger: "blur" }
        ],
        content: [
          { required: true, validator: validatorContent, trigger: "blur" }
        ],
        type: [
          { required: true, message: "还没有同意协议", trigger: "change" },
          { validator: revalidatexieyi, trigger: "change", required: true }
        ]
      }
    };
  },
  methods: {
    filedCheck(prop) {
      let noSave = false;
      this.$refs.form.validateField(prop, valid => {
        if (valid) {
          noSave = true;
        }
      });
      return noSave;
    },

    onSubmit() {
      const validateFieldList = Object.keys(this.rules);
      const noSave = validateFieldList.some(i => this.filedCheck(i));
      if (!noSave) {
        // 调用保存接口
        this.dataFormSubmit();
      }
    },

    dataFormSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$api.industry.saveNeeds(this.form).then(res => {
            if (res.data.errno == 0) {
              this.$FUnitls.showInfo("提交成功", "success");
              var form = {
                name: "",
                surname: "",
                mail: "",
                phone: "",
                company: "",
                content: ""
              };
              form.type = this.form.type;
              this.form = form;
            } else {
              this.$FUnitls.showInfo(res.data.errmsg, "error");
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    if (this.$cookies.get("userinfo") != null) {
      this.form.mail = this.$cookies.get("userinfo").mail;
      this.form.name = this.$cookies.get("userinfo").realname;
      this.form.surname = this.$cookies.get("userinfo").surname;
      this.form.phone = this.$cookies.get("userinfo").phone;
      this.form.company = this.$cookies.get("userinfo").compnay;
    }
  }
};
</script>

<style scoped>
.contents-help-box {
  width: 100%;
  background-color: #f3f5f7;
  padding: 51px 0;
  overflow: hidden;
}
.contents-help {
  width: 1000px;
  margin: 0 auto;
  padding: 0 50px;
  overflow: hidden;
}
.contents-help-right {
  float: left;
  width: 400px;
}
.contents-help-right img {
  width: 100%;
}
.contents-help-left {
  float: right;
  width: 580px;
}
.help-line {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.help-item {
  width: 48%;
}
.el-checkbox {
  display: flex;
  align-content: flex-start;
}
.contents-help-left >>> .el-checkbox__inner {
  margin-top: 3px;
}
.contents-help-left >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.contents-help-left
  >>> .el-checkbox__input.is-indeterminate
  .el-checkbox__inner {
  color: #808080;
}
.contents-help-left >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #808080;
}
.contents-help-left >>> .el-textarea__inner {
  resize: none;
}
.contents-help-left >>> .el-checkbox__label {
  width: 556px;
}
.help-button {
  text-align: center;
  font-weight: 700;
  padding: 14px 50px;
  font-size: 14px;
  border-radius: 30px;
  margin-top: 8px;
}
.mbutton {
  text-align: center;
}
.yinsi {
  font-weight: 500;
  color: #2655ae;
}
</style>



// WEBPACK FOOTER //
// src/components/industry/IndustryFrom.vue